export default {
	debounce(func: { apply: any }, wait: number, immediate: any) {
		let timeout: number;

		return function instance(this: any, args: any) {
			const context = this;

			const later = function later() {
				timeout = 0;
				if (!immediate) func.apply(context, args);
			};

			const callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},
};
